import { AbstractPerformanceRequirementProof } from './abstract-performance-requirement-proof.model';

export class ActivationPerformanceRequirementProof extends AbstractPerformanceRequirementProof {}
